export const dataHooks = {
    itemText: 'additem-text',
    itemSubtitle: 'additem-subtitle',
    itemTooltip: 'additem-tooltip',
    addItem: 'additem',
    defaultIcon: 'additem-default-icon',
};
export const SIZE = {
    large: 'large',
    medium: 'medium',
    small: 'small',
    tiny: 'tiny',
};
//# sourceMappingURL=constants.js.map